import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { fetchDocumentTypes } from "./documentTypeThunk";
import { IDocumentTypeSliceState } from "../../utils/documentType.types";

/**
 * DocumentType slice initial state.
 */
const initialState: IDocumentTypeSliceState = {
    documentTypes: [],
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * DocumentType Slice.
 */
const documentTypeSlice = createSlice({
    name: 'documentType',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch DocumentTypes
            .addCase(fetchDocumentTypes.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchDocumentTypes.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.documentTypes = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchDocumentTypes.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            });
    }
});

export default documentTypeSlice.reducer;
